var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ShareButton"}},[_c('a',{on:{"click":function($event){return _vm.openShareMenu()}}},[(!_vm.$root.shareOpen)?_c('ShareIcon'):_vm._e(),_vm._v(" "),(_vm.$root.shareOpen)?_c('div',{staticClass:"close-button"},[_c('span',{staticClass:"close-button--bar"}),_vm._v(" "),_c('span',{staticClass:"close-button--bar"})]):_vm._e()],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca40ecd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareButton.vue
// module id = null
// module chunks = 